// @ts-nocheck
import { getCookie } from "@insite/client-framework/Common/Cookies";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { emptyGuid } from "@insite/client-framework/Common/StringHelpers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { Dictionary } from "@insite/client-framework/Common/Types";
import { setMainNavigation } from "@insite/client-framework/Components/ShellHoleConnect";
import Logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    getCategoriesDataView,
    getCategoryDepthLoaded,
    getCategoryState,
    getSubCategoryIds,
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadCategories from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";
import loadCategory from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategory";
import { getPageLinkByNodeId, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { StylesContext } from "@insite/content-library/additionalStyles";
// import MainNavigationItem from "@insite/content-library/Components/MainNavigationItem"; // Foundation
// import NavigationDrawer from "@insite/content-library/Components/NavigationDrawer"; // Starter Custom Code
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
// import SearchInput, { SearchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput"; // Starter Custom Code
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
// import { IconProps } from "@insite/mobius/Icon"; // Starter Custom Code
// import Search from "@insite/mobius/Icons/Search"; // Starter Custom Code
import X from "@insite/mobius/Icons/X";
// import Link, { LinkPresentationProps } from "@insite/mobius/Link"; // Foundation
import { MenuPresentationProps } from "@insite/mobius/Menu";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { PopoverPresentationProps, PositionStyle } from "@insite/mobius/Popover";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { resolveColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import * as cssLinter from "css";
import isEqual from "lodash/isEqual";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Store Custom Code */
import Zone from "@insite/client-framework/Components/Zone";
import { getHeader } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { IconProps, IconWrapper } from "@insite/mobius/Icon";
import ArrowForward from "@store/Library/Components/Toolkit/Icons/ArrowForward";
import ChevronDown, { ChevronDownOffset } from "@store/Library/Components/Toolkit/Icons/ChevronDown";
import Search from "@store/Library/Components/Toolkit/Icons/Search";
import { sizedWrapperImageStyles } from "@store/Library/Components/Toolkit/SizedWrapper";
import NavigationDrawer from "@store/Overrides/Components/NavigationDrawer";
import SearchInput, { SearchInputStyles } from "@store/Overrides/Widgets/Header/SearchInput";
import {
    headerHideForDesktopStyles,
    headerHideForMobileStyles,
    headerMobileSelector,
} from "@store/Themes/common/mixins/header";
import { linkActionStyles, linkStyles } from "@store/Themes/common/mixins/link";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { headerIconButtonProps } from "@store/Themes/common/props/header";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusStyles, iconColorStyles, siteWidthStyles, spacingStyles } from "@toolkit/Themes/common/mixins";
import { iconScalableStyles } from "@toolkit/Themes/common/mixins";
/* Store Custom Code */

// Foundation --->
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import ArrowiOSDownward from "@store/Library/Components/Toolkit/Icons/ArrowiOSDownward";
import MainNavigationItem from "@store/Overrides/Components/MainNavigationItem";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
// <--- Foundation

// Sas --->
import BigMenu from "@store/Library/Components/BigMenu";
// <--- Sas

const enum fields {
    links = "links",
    showQuickOrder = "showQuickOrder",
    customCSS = "customCSS",
    // Foundation
    megaMenuDirection = "megaMenuDirection",
    megaMenuSize = "megaMenuSize",
    // Sas
    isOnlyBurgerMenu = "isOnlyBurgerMenu",
    additionnalsButtons = "additionnalsButtons",
    showCategoriesIcon = "showCategoriesIcon",
    megaMenuBackgroundImage = "megaMenuBackgroundImage",
    megaMenuBackgroundImageStyles = "megaMenuBackgroundImageStyles",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.links]: LinkModel[];
        [fields.showQuickOrder]: boolean;
        [fields.customCSS]: string;
        // Store Custom Code - >
        [fields.megaMenuBackgroundImage]: string;
        [fields.megaMenuBackgroundImageStyles]: "cover" | "repeat";
        // <-- Sas Custom Code
    };
    isCompactHeaderFlyoutMenu: boolean;
    flyoutCustomCSS?: string;
    showFlyoutPricingToggle?: boolean;
    showFlyoutInventoryToggle?: boolean;
    isCompactHeaderMainNavigation: boolean;
    сompactHeaderMainNavigationCustomCSS?: string;
}

interface LinkModel {
    fields: {
        openInNewWindow: boolean;
        destination: LinkFieldValue;
        linkType: "Link" | "MegaMenu" | "CascadingMenu";
        overrideTitle: string;
        title: string;
        numberOfColumns: number;
        maxDepth: number;
        // Store Custom Code
        maxChild?: number;
        maxChildren?: number;
        // Foundation
        direction: "column" | "row";
        size: "small" | "medium" | "large";
        // Sas
        buttonVariant: "none" | "primary" | "secondary" | "tertiary";
        removeFirstLevelLink?: boolean;
        showCategoriesIcon?: boolean;
    };
}

export interface MappedLink {
    title: string;
    url: string;
    type?: string;
    excludeFromNavigation?: boolean;
    openInNewWindow?: boolean;
    numberOfColumns?: number;
    maxDepth?: number;
    childrenType?: "MegaMenu" | "CascadingMenu";
    children?: MappedLink[];
    // Store Custom Code
    maxChild?: number;
    maxChildren?: number;
    // Foundation
    direction?: "column" | "row";
    size?: "small" | "medium" | "large";
    // Sas
    icon?: string;
    buttonVariant?: "none" | "primary" | "secondary" | "tertiary";
    removeFirstLevelLink?: boolean;
    showCategoriesIcon?: boolean;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const {
        fields: { links = [] },
    } = ownProps;
    const mappedLinks = [];
    const categoryIdsToLoad: Dictionary<number> = {};
    for (const link of links) {
        const {
            fields: {
                linkType,
                destination,
                openInNewWindow,
                overrideTitle,
                numberOfColumns,
                maxDepth,
                title,
                // Store Custom Code
                maxChild,
                maxChildren,
                // Foundation
                direction,
                size,
                // Sas
                buttonVariant,
                removeFirstLevelLink,
                showCategoriesIcon,
            },
        } = link;
        const { type, value } = destination;

        const depthToLoad = linkType === "MegaMenu" ? 2 : maxDepth;

        let mappedLink: MappedLink | undefined;

        if (type === "Url") {
            mappedLink = {
                url: value,
                title,
            };
        } else if (type === "Page") {
            const readonlyPageLink = getPageLinkByNodeId(state, value);
            if (readonlyPageLink) {
                mappedLink = { ...readonlyPageLink };
                if (overrideTitle) {
                    mappedLink.title = overrideTitle;
                }
            }
        } else if (type === "Category") {
            mappedLink = setupCategoryLink(
                state,
                value,
                categoryIdsToLoad,
                depthToLoad,
                overrideTitle,
                state.data.categories.categoryIdsCalled,
                showCategoriesIcon, // Store Custom Code
            );
        }

        if (!mappedLink) {
            continue;
        }

        mappedLink.openInNewWindow = openInNewWindow;
        mappedLink.numberOfColumns = numberOfColumns;
        mappedLink.maxDepth = maxDepth;
        mappedLink.maxChild = maxChild; // Store Custom Code
        mappedLink.maxChildren = maxChildren; // Store Custom Code
        // Foundation
        mappedLink.direction = direction;
        mappedLink.size = size;
        // Sas
        mappedLink.buttonVariant = buttonVariant;
        mappedLink.removeFirstLevelLink = removeFirstLevelLink;
        mappedLink.showCategoriesIcon = showCategoriesIcon;

        if (linkType === "MegaMenu" || linkType === "CascadingMenu") {
            mappedLink.childrenType = linkType;
        }

        mappedLinks.push(mappedLink);
    }

    const currentMode = getCookie(NavigationModeCookieName) || "Storefront";
    const orderSettings = getSettingsCollection(state).orderSettings;
    const session = getSession(state);
    const isAuthenticated = session?.isAuthenticated && !session?.isGuest;
    const isVmiAdmin = session.userRoles?.toLowerCase().indexOf("vmi_admin") !== -1;
    const isVmiUser = session.userRoles?.toLowerCase().indexOf("vmi_user") !== -1;

    return {
        links: mappedLinks,
        quickOrderLink: getPageLinkByPageType(state, "QuickOrderPage"),
        categoryIdsToLoad,
        allowQuickOrder: orderSettings.allowQuickOrder,
        categoryErrorStatusCodeById: state.data.categories.errorStatusCodeById,
        categoryIdsCalled: state.data.categories.categoryIdsCalled,
        displayChangeCustomerLink: session?.displayChangeCustomerLink,
        displayVmiNavigation:
            currentMode === "Vmi" && orderSettings.vmiEnabled && isAuthenticated && (isVmiAdmin || isVmiUser),
        displayModeSwitch: isAuthenticated && orderSettings.vmiEnabled && (isVmiAdmin || isVmiUser),
        currentMode,
        vmiPageLinks: isVmiAdmin
            ? [
                  getPageLinkByPageType(state, "VmiDashboardPage"),
                  getPageLinkByPageType(state, "VmiLocationsPage"),
                  getPageLinkByPageType(state, "VmiUsersPage"),
                  getPageLinkByPageType(state, "VmiBinsPage"),
                  getPageLinkByPageType(state, "VmiReportingPage"),
                  getPageLinkByPageType(state, "VmiOrderHistoryPage"),
              ]
            : isVmiUser
            ? [
                  getPageLinkByPageType(state, "VmiDashboardPage"),
                  getPageLinkByPageType(state, "VmiLocationsPage"),
                  getPageLinkByPageType(state, "VmiBinsPage"),
                  getPageLinkByPageType(state, "VmiReportingPage"),
                  getPageLinkByPageType(state, "VmiOrderHistoryPage"),
              ]
            : [],
        // Store Custom Code
        headerId: getHeader(state).id || ownProps.id,
    };
};

const getParameter = (categoryId: string, maxDepth: number) => ({
    maxDepth,
    startCategoryId: categoryId === emptyGuid ? undefined : categoryId,
    includeStartCategory: categoryId !== emptyGuid,
});

const setupCategoryLink = (
    state: ApplicationState,
    value: string,
    categoryIdsToLoad: Dictionary<number>,
    maxDepth: number,
    overrideTitle: string,
    categoryIdsCalled: string[],
    showCategoriesIcon?: boolean, // Store Custom Code
) => {
    let mappedLink: MappedLink | undefined;

    if (!value) {
        return;
    }

    const depthLoaded = getCategoryDepthLoaded(state, value);
    const subCategoryIds = getSubCategoryIds(state, value);
    if (
        (depthLoaded < maxDepth || (!subCategoryIds && !categoryIdsCalled?.includes(value))) &&
        !getCategoriesDataView(state, getParameter(value, maxDepth)).isLoading
    ) {
        categoryIdsToLoad[value] = maxDepth;
    } else {
        if (value === emptyGuid) {
            mappedLink = {
                url: "",
                title: overrideTitle || translate("Products"),
            };
        } else {
            const categoryState = getCategoryState(state, value);
            if (!categoryState.value) {
                if (
                    !categoryState.isLoading &&
                    !getCategoriesDataView(state, getParameter(value, maxDepth)).isLoading
                ) {
                    categoryIdsToLoad[value] = maxDepth;
                }
                return;
            }
            mappedLink = {
                url: categoryState.value.path,
                title: overrideTitle || categoryState.value.shortDescription,
                // Sas
                icon: showCategoriesIcon ? categoryState.value.properties.saS_CategoryIcon : "",
            };
        }

        loadSubCategories(
            mappedLink,
            subCategoryIds,
            1,
            maxDepth,
            state,
            showCategoriesIcon /* Store Custom Code - showCategoriesIcon */,
        );
    }

    return mappedLink;
};

const loadSubCategories = (
    mappedLink: MappedLink,
    subCategoryIds: readonly string[] | undefined,
    currentDepth: number,
    maxDepth: number,
    state: ApplicationState,
    showCategoriesIcon?: boolean, // Store Custom Code
) => {
    if (currentDepth > maxDepth) {
        return;
    }
    mappedLink.children = [];
    if (!subCategoryIds) {
        return;
    }
    for (const subCategoryId of subCategoryIds) {
        const subCategory = getCategoryState(state, subCategoryId).value;
        if (!subCategory) {
            Logger.error(`Category ${subCategoryId} was not found in data state, excluding from navigation.`);
            continue;
        }
        const childLink: MappedLink = {
            url: subCategory.path,
            title: subCategory.shortDescription,
            children: [],
            // Sas
            icon: showCategoriesIcon ? subCategory.properties.saS_CategoryIcon : "",
        };
        mappedLink.children.push(childLink);
        loadSubCategories(
            childLink,
            subCategory.subCategoryIds,
            currentDepth + 1,
            maxDepth,
            state,
            showCategoriesIcon /* Store Custom Code */,
        );
    }
};

const mapDispatchToProps = {
    loadCategories,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

interface State {
    selectedLinkIndex?: number;
    mobileSearchModalIsOpen: boolean;
}

export interface MainNavigationStyles {
    menuHeight: number;
    container?: InjectableCss;
    itemWrapper?: InjectableCss;
    quickOrderItemWrapper?: InjectableCss;
    menuItem?: InjectableCss;
    menuItemIcon?: IconProps;
    menuItemTypography?: TypographyPresentationProps;
    cascadingMenu?: MenuPresentationProps;
    megaMenu?: PopoverPresentationProps;
    megaMenuGridContainer?: GridContainerProps;
    megaMenuGridItem?: GridItemProps;
    megaMenuHeading?: LinkPresentationProps;
    megaMenuLink?: LinkPresentationProps;
    mobileWrapper?: InjectableCss;
    compactFlyoutMenu?: InjectableCss;
    mobileMenuWrapper?: InjectableCss;
    mobileSearchButton?: ButtonPresentationProps;
    mobileSearchWrapper?: InjectableCss;
    mobileSearchModal?: ModalPresentationProps;
    mobileSearchInputWrapper?: InjectableCss;
    mobileSearchInputStyles?: SearchInputStyles;
    mobileSearchModalCloseIcon?: IconProps;
    // Store Custom Code
    mainWrapper?: InjectableCss;
    desktopWrapper?: InjectableCss;
    megaMenuContentWrapper?: InjectableCss;
    megaMenuViewAllLink?: LinkPresentationProps;
    megaMenuSeeMoreLink?: LinkPresentationProps;
    megaMenuChildren?: InjectableCss;
    mobileLogoWrapper?: InjectableCss;
    // Foundation
    quickOrderLink?: LinkPresentationProps;
    menuLinkButton?: ButtonPresentationProps;
    megaMenuContainerWrapper?: InjectableCss;
    megaMenuListItem?: TypographyPresentationProps;
}

export const mainNavigationStyles: MainNavigationStyles = {
    menuHeight: 50,
    container: {
        css: css`
            display: flex;
            justify-content: left;
        `,
    },
    itemWrapper: {
        css: css`
            display: flex;
            align-items: center;

            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        css`
                            ${contentSpacingStyles(0, pxToRem(15), 0)}
                        `,
                        null,
                        css`
                            ${contentSpacingStyles(0, pxToRem(10), 0)}
                        `,
                        css`
                            ${contentSpacingStyles(0, pxToRem(35), 0)}
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    quickOrderItemWrapper: {
        css: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            ${contentSpacingStyles(0, pxToRem(15), 0)}
                        `,
                        null,
                        null,
                        css`
                            ${contentSpacingStyles(0, pxToRem(35), 0)}
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    megaMenuGridItem: {
        css: css`
            display: flex;
            flex-direction: column;
            min-width: 12em;
            padding: 0;
            margin-bottom: ${pxToRem(25)} !important; /* Most override inner propriety */
        `,
    },
    megaMenuHeading: {
        css: css`
            font-weight: ${({ theme }) => theme.design.typography.weight.medium};
            margin-bottom: ${pxToRem(10)};

            &:hover {
                color: ${getColor("secondary")};
            }
        `,
    },
    megaMenuLink: {
        typographyProps: {
            color: "text.main",
            underline: false,
            css: css`
                font-weight: ${({ theme }) => theme.design.typography.weight.base};
                line-height: ${({ theme }) => theme.design.typography.lineHeight.small};

                &:hover {
                    color: ${getColor("secondary")};
                    text-decoration: none;
                }
            `,
        },
    },
    megaMenuListItem: {
        css: css`
            ${contentSpacingStyles(0, 0, "0.25em")}
        `,
    },
    menuItem: {},
    menuItemIcon: {
        css: css`
            margin: ${pxToRem(-3)} 0 0 ${pxToRem(10)};
        `,
        size: 18,
    },
    menuItemTypography: {},
    megaMenu: {
        transitionDuration: "short",
        contentBodyProps: {
            _height: pxToRem(1200),
            css: css`
                position: static;
                padding: 1em 0;
                box-shadow: ${({ theme }) => theme.shadows.main};
            `,
        },
        wrapperProps: {
            css: css`
                position: static !important; /* Most be important because it's not overridable */
            `,
        },
    },
    megaMenuGridContainer: {},
    megaMenuContainerWrapper: {
        css: css`
            ${siteWidthStyles()}
        `,
    },
    mobileSearchButton: {
        size: 48,
        buttonType: "solid",
        color: "secondary",
        css: css`
            padding: 0 ${pxToRem(10)};
        `,
    },
    mobileWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
        `,
    },
    compactFlyoutMenu: {
        css: css`
            & button {
                background: transparent;
                border: none;
                &:hover {
                    background: rgba(0, 0, 0, 0.3);
                }

                svg {
                    color: ${props => resolveColor(props.theme.header.linkColor, props.theme)};
                }
            }
        `,
    },
    mobileSearchWrapper: {
        css: css`
            text-align: right;
        `,
    },
    mobileMenuWrapper: {
        css: css`
            text-align: right;
        `,
    },
    mobileSearchInputWrapper: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    mobileSearchInputStyles: {
        input: {
            cssOverrides: {
                formField: css`
                    width: 100%;
                `,
            },
        },
        popover: {
            wrapperProps: {
                css: css`
                    width: calc(100% - ${pxToRem(45)});
                `,
            },
        },
        popoverContentBody: {
            as: "div",
            _height: "100%",
            css: css`
                box-shadow: none;
            `,
        },
        autocompleteWrapper: {
            css: css`
                display: flex;
                flex-direction: column;
            `,
        },
        autocompleteColumnWrapper: {
            css: css`
                display: flex;
                flex-direction: column;
                width: 100%;
                padding: 0 ${pxToRem(50)} 0 ${pxToRem(30)};
            `,
        },
        searchHistoryStyles: {
            wrapper: {
                css: css`
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    padding: 0 ${pxToRem(50)} ${pxToRem(15)} ${pxToRem(30)};
                `,
            },
        },
        autocompleteProductsStyles: {
            titleLink: {
                css: css`
                    width: 100%;
                `,
            },
            erpNumberText: {
                css: css`
                    width: 100%;
                    text-align: left;
                    margin: ${pxToRem(5)} 0 0 0;
                `,
            },
        },
    },
    mobileSearchModalCloseIcon: {
        src: X,
        size: 18,
        css: css`
            margin-left: ${pxToRem(10)};
        `,
    },
    menuLinkButton: {
        icon: {
            src: ArrowiOSDownward,
            position: "right",
        },
        css: css`
            ${({ theme }) => theme.button.primary.css}
            display: inline-flex;
            align-items: center;
            padding: ${pxToRem(10)} ${pxToRem(10)};
            font-weight: ${({ theme }) => theme.design.typography.weight.bold};

            ${breakpoint("lg")} {
                padding: ${pxToRem(10)} ${pxToRem(15)};
                font-size: ${({ theme }) => theme.design.typography.size.base};

                ${ButtonIcon} {
                    margin-right: ${pxToRem(-10)};
                }
            }

            ${ButtonIcon} {
                top: 0;
                margin-right: 0;
                margin-left: ${pxToRem(5)};
                /* Sas Removed Code */
            }
        `,
    },
    quickOrderLink: {
        typographyProps: {
            css: css`
                font-weight: ${({ theme }) => theme.design.typography.weight.medium};
            `,
        },
        css: css`
            ${linkStyles("primary", "secondary", false, false)}
            font-size: ${({ theme }) => theme.design.typography.size.smaller};

            ${breakpoint("lg")} {
                font-size: ${({ theme }) => theme.design.typography.size.base};
            }
        `,
    },
};

/* Store Custom Code */
const defaultCustomCss = `.mobile-wrapper {
}

.mobile-menu-wrapper {
}

.menu-trigger-button {
}

.menu-trigger-button-icon {
}

.drawer {
}

.drawer-section-wrapper {
}

.panel-menu {
}

.main-navigation-row {
}

.panel-section-wrapper {
}

.main-navigation-row-icon {
}

.user-row-text {
}

.punch-out-navigation-row-icon {
}

.punch-out-user-row-text {
}

.main-navigation-row-text {
}

.logo-links-row {
}

.logo-link-title {
}

.language-image {
}

.menu-row-icon {
}

.change-customer-row {
}

.change-customer-row-container {
}

.fulfillment-method-grid-item {
}

.addresses-grid-item {
}

.pick-up-address-grid-item {
}

.apply-button-grid-item {
}

.sign-out-row {
}

.sign-out-row-text {
}

.mobile-search-wrapper {
}

.mobile-search-button {
}

.mobile-search-button-icon {
}

.container {
}

.item-wrapper {
}

.cascading-menu {
}

.menu-item {
}

.mega-menu {
}

.mega-menu-grid-container {
}

.mega-menu-grid-item {
}

.mega-menu-heading-link {
}

.mega-menu-link {
}

.quick-order-item-wrapper {
}

.quick-order-link {
}

.vmi-page-link {
}

.mobile-search-modal {
}`;
/* Store Custom Code */

export class MainNavigation extends React.Component<Props, State> {
    container = React.createRef<HTMLUListElement>(); // Store Custom Code
    mobileSearchInput = React.createRef<HTMLInputElement>();
    declare context: React.ContextType<typeof StylesContext>;

    constructor(props: Props) {
        super(props);

        this.state = {
            mobileSearchModalIsOpen: false,
        };
    }

    UNSAFE_componentWillMount(): void {
        this.loadCategoriesIfNeeded();

        setMainNavigation({
            close: () => {
                this.setState({
                    selectedLinkIndex: undefined,
                });
            },
            openMenu: (index: number) => {
                this.setState({
                    selectedLinkIndex: index,
                });
            },
        });
    }

    componentDidUpdate(prevProps: Readonly<Props>): void {
        if (!isEqual(this.props.categoryIdsToLoad, prevProps.categoryIdsToLoad)) {
            this.loadCategoriesIfNeeded(true);
        }
    }

    loadCategoriesIfNeeded(isComponentDidUpdate = false) {
        const { categoryIdsToLoad } = this.props;
        for (const categoryId of Object.keys(categoryIdsToLoad)) {
            if (!this.props.categoryErrorStatusCodeById?.[categoryId]) {
                const maxDepth = categoryIdsToLoad[categoryId];
                if (!this.props.categoryIdsCalled?.includes(categoryId) || isComponentDidUpdate) {
                    this.props.loadCategories(getParameter(categoryId, maxDepth));
                }
            }
        }
    }

    getMobileSearchAutocompletePosition = (element: React.RefObject<HTMLUListElement>) => {
        const positionStyle: PositionStyle = {
            position: "fixed",
        };

        if (element.current) {
            const rect = element.current.getBoundingClientRect();
            positionStyle.top = rect.top + rect.height;
            positionStyle.left = 0;
            positionStyle.width = `${document.documentElement.clientWidth}px`;
            positionStyle.height = `${document.documentElement.clientHeight - positionStyle.top}px`;
        }

        return positionStyle;
    };

    mobileSearchButtonClickHandler = () => {
        this.setState({ mobileSearchModalIsOpen: true }, () => {
            setTimeout(() => {
                if (this.mobileSearchInput?.current) {
                    this.mobileSearchInput.current.focus();
                    this.mobileSearchInput.current.click();
                }
            }, 250);
        });
    };

    mobileSearchModalCloseHandler = () => {
        this.setState({ mobileSearchModalIsOpen: false });
    };

    render() {
        const {
            links,
            quickOrderLink,
            fields: { showQuickOrder, customCSS, megaMenuBackgroundImage, megaMenuBackgroundImageStyles },
            id,
            allowQuickOrder,
            isCompactHeaderFlyoutMenu,
            flyoutCustomCSS,
            showFlyoutPricingToggle,
            showFlyoutInventoryToggle,
            isCompactHeaderMainNavigation,
            сompactHeaderMainNavigationCustomCSS,
            vmiPageLinks,
            displayVmiNavigation,
            displayModeSwitch,
            currentMode,
            // Store Custom Code
            headerId,
        } = this.props;
        const { selectedLinkIndex } = this.state;

        const showQuickOrderLink = showQuickOrder && allowQuickOrder;
        const mainNavContextStyles = this?.context?.styles?.mainNavigation ?? {};
        const styles = mergeProps(mainNavigationStyles, mainNavContextStyles); // Store Custom Code

        if (isCompactHeaderFlyoutMenu) {
            /* Store Custom Code */
            const flyoutCustomCssWrapper = css`
                ${styles.compactFlyoutMenu?.css}
                ${flyoutCustomCSS}
            `;
            /* Store Custom Code */

            return (
                <StyledWrapper
                    className="flyout-menu-wrapper"
                    {...styles.compactFlyoutMenu}
                    // Store Custom Code
                    css={flyoutCustomCssWrapper}
                >
                    <NavigationDrawer
                        links={links}
                        showQuickOrder={showQuickOrderLink}
                        quickOrderLink={quickOrderLink}
                        displayVmiNavigation={displayVmiNavigation}
                        vmiPageLinks={vmiPageLinks}
                        displayModeSwitch={displayModeSwitch}
                        currentMode={currentMode}
                        isCompactHeaderFlyout={true}
                        showFlyoutPricingToggle={showFlyoutPricingToggle}
                        showFlyoutInventoryToggle={showFlyoutInventoryToggle}
                        // Store Custom Code
                        uniqueId={id}
                    />
                </StyledWrapper>
            );
        }

        if (isCompactHeaderMainNavigation) {
            const mainNavigationCustomCSSWrapper = {
                css: css`
                    ${сompactHeaderMainNavigationCustomCSS}
                `,
            };

            return (
                <StyledWrapper {...mainNavigationCustomCSSWrapper}>
                    <StyledWrapper
                        className="container"
                        {...styles.container}
                        ref={this.container}
                        // Store Custom Code
                        as="ul"
                    >
                        {links.map((link, index) => {
                            return (
                                // eslint-disable-next-line react/no-array-index-key
                                <StyledWrapper className="item-wrapper" {...styles.itemWrapper} key={index}>
                                    <MainNavigationItem
                                        index={index}
                                        link={link}
                                        styles={styles}
                                        container={this.container}
                                        isOpen={index === selectedLinkIndex}
                                        displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                                    />
                                </StyledWrapper>
                            );
                        })}
                        {showQuickOrderLink && quickOrderLink && (
                            <StyledWrapper className="item-wrapper" {...styles.itemWrapper}>
                                <StyledWrapper className="quick-order-item-wrapper" {...styles.quickOrderItemWrapper}>
                                    <Link
                                        className="quick-order-link"
                                        typographyProps={styles.menuItemTypography}
                                        color={styles.menuItemTypography?.color}
                                        {...styles.menuItem}
                                        id="quickOrder"
                                        href={quickOrderLink.url}
                                    >
                                        {quickOrderLink.title}
                                    </Link>
                                </StyledWrapper>
                            </StyledWrapper>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
            );
        }

        const customCssWrapper = {
            css: css`
                ${customCSS}
            `,
        };

        return (
            <StyledWrapper {...customCssWrapper}>
                <StyledWrapper className="mobile-wrapper" {...styles.mobileWrapper}>
                    {/* Sas - Big menu */}
                    <Hidden below="md" {...styles.mobileMenuWrapper}>
                        <BigMenu
                            menuZoneId={this.props.id}
                            link={links[0]}
                            backgroundImage={megaMenuBackgroundImage}
                            backgroundImageStyles={megaMenuBackgroundImageStyles}
                        />
                    </Hidden>
                    <Hidden className="mobile-menu-wrapper" above="sm" {...styles.mobileMenuWrapper}>
                        <NavigationDrawer
                            links={links}
                            showQuickOrder={showQuickOrderLink}
                            quickOrderLink={quickOrderLink}
                            displayVmiNavigation={displayVmiNavigation}
                            vmiPageLinks={vmiPageLinks}
                            displayModeSwitch={displayModeSwitch}
                            currentMode={currentMode}
                        />
                    </Hidden>
                    {/* Starter Removed Code - Search Icon */}
                </StyledWrapper>
                {/* Sas - below md */}
                {/* Sas Removed Code - MainNavigationItems */}
                <Modal
                    className="mobile-search-modal"
                    {...styles.mobileSearchModal}
                    isOpen={this.state.mobileSearchModalIsOpen}
                    closeOnEsc={true}
                    handleClose={this.mobileSearchModalCloseHandler}
                    // Starter Custom - moved SearchInput inside modal (headline)
                >
                    <SearchInput
                        id={id}
                        inputRef={this.mobileSearchInput}
                        // Starter Removed  - autocompletePositionFunction
                        onBeforeGoToUrl={this.mobileSearchModalCloseHandler}
                        extendedStyles={styles.mobileSearchInputStyles}
                    />
                </Modal>
            </StyledWrapper>
        );
    }
}

MainNavigation.contextType = StylesContext;

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const mainNavigation: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MainNavigation),
    definition: {
        group: "Header",
        icon: "magnifying-glass",
        allowedContexts: ["Header"],
        fieldDefinitions: [
            {
                name: fields.links,
                editorTemplate: "ListField",
                onEditRow: (index: number, dispatch) => {
                    dispatch({
                        type: "SendToSite/OpenMainNavigation",
                        index,
                    });
                },
                onDoneEditingRow: dispatch => {
                    dispatch({
                        type: "SendToSite/CloseMainNavigation",
                    });
                },
                onLoad: dispatch => {
                    dispatch({
                        type: "SendToSite/CloseMainNavigation",
                    });
                },
                getDisplay: (item: HasFields, state) => {
                    const { type, value } = item.fields.destination;
                    const { overrideTitle, title } = item.fields;
                    if (type === "Page") {
                        const link = getPageLinkByNodeId(state, value);
                        return overrideTitle || link?.title;
                    }
                    if (type === "Category") {
                        if (overrideTitle) {
                            return overrideTitle;
                        }
                        if (value === emptyGuid) {
                            return "Products";
                        }
                        const categoryState = getCategoryState(state, value);
                        if (!categoryState.value) {
                            if (!categoryState.isLoading && value) {
                                return dispatch => {
                                    dispatch(
                                        loadCategory({
                                            id: value,
                                        }),
                                    );
                                };
                            }
                            return "";
                        }
                        return categoryState.value.shortDescription;
                    }
                    if (type === "Url") {
                        return title ?? value;
                    }
                    return value;
                },
                defaultValue: [],
                fieldType: "Translatable",
                tab: basicTab,
                fieldDefinitions: [
                    // Sas Removed Code -- Link type
                    {
                        name: "destination",
                        editorTemplate: "LinkField",
                        defaultValue: {
                            value: "",
                            type: "Page",
                        },
                        isRequired: true,
                        // Sas Removed Code
                        showCategoryRoot: item => true,
                    },
                    // Sas -- Overriden Title
                    {
                        name: "title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        // Sas
                    },
                    {
                        name: "numberOfColumns",
                        editorTemplate: "DropDownField",
                        defaultValue: 6,
                        options: [{ value: 2 }, { value: 3 }, { value: 4 }, { value: 6 }, { value: 8 }], // Sas
                        isRequired: true,
                        // Sas Removed Code
                    },
                    // Sas Removed Code -- Max Depth
                    // Sas Removed Code -- Open in new window
                    // Store Custom Code - >
                    {
                        name: "removeFirstLevelLink",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                    },
                    {
                        name: "showCategoriesIcon",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                    },
                    {
                        name: "buttonVariant",
                        displayName: "Button Variant",
                        editorTemplate: "DropDownField",
                        options: [
                            { displayName: "None", value: "none" },
                            { displayName: "Primary", value: "primary" },
                            { displayName: "Secondary", value: "secondary" },
                            { displayName: "Tertiary", value: "tertiary" },
                        ],
                        defaultValue: "none",
                    },
                ],
            },
            {
                name: fields.megaMenuBackgroundImage,
                fieldType: "Translatable",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: advancedTab,
            },
            {
                name: fields.megaMenuBackgroundImageStyles,
                displayName: "Mega Menu Background Image Styles",
                editorTemplate: "DropDownField",
                fieldType: "General",
                options: [
                    { displayName: "Cover", value: "cover" },
                    { displayName: "Repeat", value: "repeat" },
                ],
                defaultValue: "cover",
                tab: advancedTab,
                isVisible: widget => widget.fields.megaMenuBackgroundImage,
            },
            // <--- Sas Custom Code

            // Sas Removed Code
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default mainNavigation;
